module.exports = __webpack_public_path__ + "assets/img/84ca-vn.svg";